export const enum EDocType {
  CIVIL = 'civil',
  PASSPORT = 'passport',
  DRIVERS_LICENSE = 'drivers_license',
  OTHER = 'other',
}
